export default {
    path: "/api/help",
    component: () => import("~/pages/api/help.vue"),
    meta: {
        layout: "help",
        isPublic: true,
    }
}